import { render } from "./card.vue?vue&type=template&id=79d3fb0c&scoped=true"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"

import "./card.vue?vue&type=style&index=0&id=79d3fb0c&lang=scss&scoped=true"
import "./card.vue?vue&type=style&index=1&id=79d3fb0c&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d3fb0c"]])

export default __exports__